import {
  createElement,
  type AnchorHTMLAttributes,
  type ComponentType,
  type ImgHTMLAttributes,
} from "react";

export type VelvetImagePrimitiveProps = ImgHTMLAttributes<HTMLImageElement> & {
  alt: string;
  imageClassName?: string;
  priority?: boolean;
  src: string;
};

export type VelvetLinkPrimitiveProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
};

export type VelvetPrimitiveRegistry = {
  Image: ComponentType<VelvetImagePrimitiveProps>;
  Link: ComponentType<VelvetLinkPrimitiveProps>;
};

export type VelvetPrimitiveName = keyof VelvetPrimitiveRegistry;

const Image = ({ imageClassName, priority: _priority, ...props }: VelvetImagePrimitiveProps) =>
  createElement("img", {
    ...props,
    className: [props.className, imageClassName].filter(Boolean).join(" ") || undefined,
  });

const Link = ({ children, rel, target, ...props }: VelvetLinkPrimitiveProps) =>
  createElement(
    "a",
    { ...props, rel: target === "_blank" && !rel ? "noopener noreferrer" : rel, target },
    children,
  );

const registry: VelvetPrimitiveRegistry = { Image, Link };

export function registerComponent<K extends VelvetPrimitiveName>(
  name: K,
  component: VelvetPrimitiveRegistry[K],
) {
  registry[name] = component;
}

export function getComponent<K extends VelvetPrimitiveName>(name: K): VelvetPrimitiveRegistry[K] {
  return registry[name];
}
